import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ["Evenings lost searching for progressions that actually work, flow logically, and fit your student's specific level", 'Sessions that feel repetitive — because you keep returning to the same drills and concepts you already know', 'Visible improvisation that quietly erodes your confidence as a coach', 'No real variety between weeks — and students who slowly lose motivation without knowing exactly why', 'Weekends spent planning instead of resting, recharging, or living your life'];
export function PainPoints() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-134" data-mp="1o03kg21d2btp">
      <div className="max-w-3xl mx-auto" data-id="element-135" data-mp="1o1ej5nfy8tdy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-136" data-mp="1sy4yu9nudmyu">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-brand" data-id="element-137" data-mp="3ncfnoi4fsh4m">Does this sound familiar?</h2>
          <div className="text-lg text-ink/80 leading-relaxed bg-cream p-6 rounded-2xl border border-mist text-left" data-id="element-138" data-mp="1yzvhzf80mjsv">
            <p data-id="element-139" data-mp="1u0sn2nlr1tym">
              Sunday evening. 10 PM. You have a golf lesson tomorrow morning. And you're still here — searching online,
              trying to build a session structure that actually flows — one that fits your student's level, feels
              professional, and doesn't look like it was thrown together in twenty minutes.
            </p>
            <p className="mt-6" data-id="element-140" data-mp="1b2zjrk77ri0p">
              <span className="text-forest font-medium" data-id="element-141" data-mp="1b3rfcv0t9fqz">Not because you don't know golf.</span> Because no one ever gave
              you a complete, structured, ready-to-teach library. You've been building every session from scratch.
            </p>
            <p className="mt-6" data-id="element-142" data-mp="1k5qxxrrh4rw1">
              The time you should be resting — you spend planning. And the worst part isn't the exhaustion. The worst
              part is showing up on the range feeling like you could have been better prepared.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-143" data-mp="1t7ho08jnmk37">
          <h3 className="text-xl font-bold text-brand mb-8 text-center" data-id="element-144" data-mp="223qpdsr6zsrz">
            The Real Cost of Not Having the Right Resource:
          </h3>
          <ul className="space-y-4" data-id="element-145" data-mp="1afgk2rs0w3mx">
            {painPoints.map((point, index) => <motion.li key={point} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-cream p-4 rounded-xl border border-sand" data-id="element-146" data-mp="1efr06x9j4afi" data-mpi={index}>
                <span className="text-red-700 mt-1" aria-hidden="true" data-id="element-147" data-mp="qollilfbro6s">
                  ●
                </span>
                <span className="text-ink/80" data-id="element-148" data-mp="vneovl0wdyt8">{point}</span>
              </motion.li>)}
          </ul>
          <div className="text-center mt-12 pt-8 border-t border-mist" data-id="element-149" data-mp="j7ezf4gl74ir">
            <p className="text-2xl font-serif font-bold text-brand" data-id="element-150" data-mp="j52imumkf07a">
              Stop giving away your free time. Your dedication is already there. What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-gold-dark font-semibold" data-id="element-151" data-mp="a8jwc18uaajo">
              Solve a Full Year of Golf Lessons in Just 5 Minutes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}